export function cleanLineBreaks (text) {
    return text.replace(/<br\s*\/?>/gi, ' ')
}